import React, { useMemo } from "react";
import { SelectInput, required } from "react-admin";

import { useFieldLabel } from "ra-friendsofbabba";

const numbers = Array.from(Array(19).keys());
const CHOICES = numbers.map((id) => ({ id }));

const MonthInput = ({ allowEmpty = false, minValue, maxValue, ...props }) => {
  const fieldLabel = useFieldLabel({ ...props });
  const choices = useMemo(
    () =>
      (allowEmpty ? CHOICES : CHOICES.filter(({ id }) => id > 0)).filter(
        ({ id }) =>
          (!minValue || id >= minValue) && (!maxValue || id <= maxValue)
      ),
    [allowEmpty, minValue, maxValue]
  );
  return (
    <SelectInput
      {...props}
      source={props.source}
      validate={required()}
      choices={choices}
      optionText="id"
      translateChoice={false}
      helperText={fieldLabel(`${props.source}.help`)}
    />
  );
};
export default MonthInput;
